/* eslint-disable complexity */
import React from 'react'

import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import {Alert, CircularProgress, Snackbar} from '@mui/material'
import styled from 'styled-components'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import useProfile from 'logic/Profile/useProfile.js'
import {Page} from 'components/Page/index.js'
import PhoneInput from 'components/Control/PhoneInput.js'

const Profile = () => {
    const {
        user,
        userNotFound,
        profileData,
        profileImageUrl,
        isProfileLoading,
        isImageLoading,
        isSaveProfile,
        t18Profile,
        handleInputChange,
        handleImageChange,
        handleSubmit,
        snackbarOpen,
        handleSnackbarClose,
        snackbarMessage,
        snackbarSeverity,
        phoneError,
        phoneCountry,
        handlePhoneCountryChange,
    } = useProfile()

    const {firstName, lastName, email, phone} = profileData

    if (isProfileLoading) {
        return (
            <Page>
                <CircularProgress />
            </Page>
        )
    }
    if (userNotFound) {
        return (
            <Page>
                <div>user not found</div>
            </Page>
        )
    }

    return (
        <Page>
            <Container onSubmit={handleSubmit} noValidate>
                <ProfileUploadContainer>
                    {isImageLoading ? (
                        <CircularProgress />
                    ) : (
                        <StyledAvatar
                            src={profileImageUrl || user.profileImageUrl}
                        />
                    )}
                </ProfileUploadContainer>
                <Button
                    component="label"
                    variant="contained"
                    startIcon={<CloudUploadIcon />}
                    disabled={isImageLoading}>
                    {t18Profile('upload')}
                    <Input
                        accept="image/*"
                        id="profile-image-upload"
                        type="file"
                        onChange={handleImageChange}
                    />
                </Button>
                <StyledTextField
                    margin="normal"
                    fullWidth
                    id="firstName"
                    label={t18Profile('firstName')}
                    name="firstName"
                    autoComplete="firstName"
                    autoFocus
                    value={firstName}
                    onChange={handleInputChange}
                />
                <StyledTextField
                    margin="normal"
                    fullWidth
                    id="lastName"
                    label={t18Profile('lastName')}
                    name="lastName"
                    autoComplete="lastName"
                    value={lastName}
                    onChange={handleInputChange}
                />
                <StyledTextField
                    margin="normal"
                    fullWidth
                    id="email"
                    label={t18Profile('email')}
                    name="email"
                    autoComplete="email"
                    value={email}
                    disabled
                    onChange={handleInputChange}
                />
                <PhoneInput
                    country={phoneCountry}
                    number={phone}
                    onCountryChange={handlePhoneCountryChange}
                    onNumberChange={handleInputChange}
                    countryLabel={t18Profile('phoneCountry')}
                    numberLabel={t18Profile('phone')}
                    error={phoneError}
                    helperText={phoneError && t18Profile('invalidPhone')}
                />
                <Button
                    type="submit"
                    variant="contained"
                    disabled={isSaveProfile || isImageLoading}>
                    {!isSaveProfile ? (
                        t18Profile('save')
                    ) : (
                        <CircularProgress sx={{color: 'info'}} size={20} />
                    )}
                </Button>
            </Container>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}>
                <Alert
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                    sx={{width: '350px'}}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Page>
    )
}

export default Profile

const Container = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 15px;

    @media (max-width: 600px) {
        padding: 10px;
    }
`

const ProfileUploadContainer = styled.div`
    width: 150px;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 600px) {
        width: 100px;
        height: 100px;
    }
`

const Input = styled.input`
    display: none;
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
`

const StyledAvatar = styled(Avatar)`
    && {
        width: 150px;
        height: 150px;
        @media (max-width: 600px) {
            width: 100px;
            height: 100px;
        }
    }
`

const StyledTextField = styled(TextField)`
    && {
        width: 450px;
        @media (max-width: 600px) {
            width: 250px;
        }
    }
`
